// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectPersonnelClaimsReport  {
    _originalTypeClassName = "Loom.BO.ProjectPersonnelClaimsReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectPersonnelClaimsReport.translate = translateService;
}
this.ProjectCostsReportDetails = [];
this.PerEmployeeDetails = [];
this.Id = null;
this.StartDate = null;
this.EndDate = null;
this.StartMonth = null;
this.EndMonth = null;
this.TotalPersonHours = null;
this.TotalPersonMonths = null;
this.TotalPMPercentage = null;
this.PersonnelCosts_A1A2A3_actuals = null;
this.PersonnelCosts_A1A2A3_unit = null;
this.PersonnelCosts_A4_unit = null;
this.PersonnelCosts = null;
this.IndirectCosts = null;
this.TotalEstimatedEligibleCosts = null;
this.FundingRate = null;
this.MaxEUContribution = null;
this.PersonnelCostsPercentage = null;
this.PeriodPercentage = null;
this.ProjectAcronym = null;
this.ActualPMRate = null;
this.DailyRatesCalculationMethod = null;
this.TotalDayEquivalents = null;
this.PMRateDeviation = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
StartDate:any;
EndDate:any;
StartMonth:any;
EndMonth:any;
TotalPersonHours:any;
TotalPersonMonths:any;
TotalPMPercentage:any;
PersonnelCosts_A1A2A3_actuals:any;
PersonnelCosts_A1A2A3_unit:any;
PersonnelCosts_A4_unit:any;
PersonnelCosts:any;
IndirectCosts:any;
TotalEstimatedEligibleCosts:any;
FundingRate:any;
MaxEUContribution:any;
PersonnelCostsPercentage:any;
PeriodPercentage:any;
ProjectAcronym:any;
ActualPMRate:any;
DailyRatesCalculationMethod:any;
TotalDayEquivalents:any;
PMRateDeviation:any;
Project:any;
Beneficiary:any;
ProjectCostsReportDetails:any;
PerEmployeeDetails:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
}
}
static setBeneficiary = ($this, value) => {
var oldValue = $this.Beneficiary;
$this.Beneficiary = value;
if (value != null) {
}
}
static setProjectCostsReportDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.ProjectCostsReportDetails == null) $this.ProjectCostsReportDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ProjectCostsReportDetails.length > 0) {
                    Domain.ProjectPersonnelClaimsReport.removeProjectCostsReportDetails($this, $this.ProjectCostsReportDetails[0]);
                }

                Domain.ProjectPersonnelClaimsReport.addManyProjectCostsReportDetails($this, copyItems);
            }
static addManyProjectCostsReportDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectPersonnelClaimsReport.addProjectCostsReportDetails($this, items[i]);
                }
            }
static addProjectCostsReportDetails = ($this, item) => {
                if ($this.ProjectCostsReportDetails == null) $this.ProjectCostsReportDetails = [];
                if (item == null || $this.ProjectCostsReportDetails.indexOf(item) > -1) return;
                $this.ProjectCostsReportDetails.push(item);
if (item.ProjectCostsReport != $this) {
Domain.ProjectPersonnelClaimsReportMonthDetail.setProjectCostsReport(item, $this);
}
}
static addRangeProjectCostsReportDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectPersonnelClaimsReport.addProjectCostsReportDetails($this, item));
            }
static removeProjectCostsReportDetails = ($this, item) => {
                if ($this == null || $this.ProjectCostsReportDetails == null || $this.ProjectCostsReportDetails.indexOf(item) === -1) return;
                var _index = $this.ProjectCostsReportDetails.indexOf(item);
                $this.ProjectCostsReportDetails.splice(_index, 1);
item.ProjectCostsReport = null;
}
static clearProjectCostsReportDetails = ($this) => { $this.ProjectCostsReportDetails = null; }
static setPerEmployeeDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.PerEmployeeDetails == null) $this.PerEmployeeDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PerEmployeeDetails.length > 0) {
                    Domain.ProjectPersonnelClaimsReport.removePerEmployeeDetails($this, $this.PerEmployeeDetails[0]);
                }

                Domain.ProjectPersonnelClaimsReport.addManyPerEmployeeDetails($this, copyItems);
            }
static addManyPerEmployeeDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectPersonnelClaimsReport.addPerEmployeeDetails($this, items[i]);
                }
            }
static addPerEmployeeDetails = ($this, item) => {
                if ($this.PerEmployeeDetails == null) $this.PerEmployeeDetails = [];
                if (item == null || $this.PerEmployeeDetails.indexOf(item) > -1) return;
                $this.PerEmployeeDetails.push(item);
if (item.Report != $this) {
Domain.ProjectPersonnelClaimsEmployeeSummary.setReport(item, $this);
}
}
static addRangePerEmployeeDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectPersonnelClaimsReport.addPerEmployeeDetails($this, item));
            }
static removePerEmployeeDetails = ($this, item) => {
                if ($this == null || $this.PerEmployeeDetails == null || $this.PerEmployeeDetails.indexOf(item) === -1) return;
                var _index = $this.PerEmployeeDetails.indexOf(item);
                $this.PerEmployeeDetails.splice(_index, 1);
item.Report = null;
}
static clearPerEmployeeDetails = ($this) => { $this.PerEmployeeDetails = null; }

static GetActualPMRate($this: any): any{if (CLMS.Framework.Number.LessThanOrEqual(() => $this.TotalPersonMonths, () => 0)) {return 0;}
return Joove.Common.safeNumber($this?.PersonnelCosts) / Joove.Common.safeNumber($this?.TotalPersonMonths);
}
static GetEndMonth($this: any): any{return Domain.Project.GetProjectMonthByDate($this?.Project, $this?.EndDate);
}
static GetIndirectCostsForPersonnel($this: any): any{let rate = 0.25;
if (($this?.Project != null && CLMS.Framework.Number.GreaterThan(() => $this.Project.IndirectCostsPercentage, () => 0))) {rate = $this?.Project?.IndirectCostsPercentage;}
let baseAmount = Domain.ProjectPersonnelClaimsReport.GetPersonnelCosts($this);
return Joove.Common.mathRound(Joove.Common.safeNumber(rate) * Joove.Common.safeNumber(baseAmount), 2);
}
static GetMaxEUContribution($this: any): any{return Joove.Common.safeNumber(Domain.ProjectPersonnelClaimsReport.GetTotalEstimatedEligibleCosts($this)) * Joove.Common.safeNumber($this?.FundingRate);
}
static GetPeriodPercentage($this: any): any{if (($this?.Project == null || CLMS.Framework.Number.LessThanOrEqual(() => $this.Project.Duration, () => 0))) {return 0;}
let months = Joove.Common.safeNumber(Domain.ProjectPersonnelClaimsReport.GetEndMonth($this)) - Joove.Common.safeNumber(Domain.ProjectPersonnelClaimsReport.GetStartMonth($this)) + Joove.Common.safeNumber(1);
return Joove.Common.safeNumber((parseFloat((months) as any))) / Joove.Common.safeNumber(($this?.Project?.Duration));
}
static GetPersonnelCosts($this: any): any{return Joove.Common.safeNumber(Domain.ProjectPersonnelClaimsReport.GetPersonnelCosts_A1A2A3_actuals($this)) + Joove.Common.safeNumber(Domain.ProjectPersonnelClaimsReport.GetPersonnelCosts_A1A2A3_unit($this)) + Joove.Common.safeNumber(Domain.ProjectPersonnelClaimsReport.GetPersonnelCosts_A4_unit($this));
}
static GetPersonnelCosts_A1A2A3_actuals($this: any): any{return Joove.Common.safeNumber($this?.PerEmployeeDetails?.linq?.where((a) => (a?.EmploymentType?.ECEmployeeCategory?.Code == "A1") && a?.EmploymentType?.CostCalculationType == Domain.ECCostCalculationTypes.ActualCosts)?.toArray()?.linq?.sum((a) => a?.Cost)) + Joove.Common.safeNumber($this?.PerEmployeeDetails?.linq?.where((a) => (a?.EmploymentType?.ECEmployeeCategory?.Code == "A2" || a?.EmploymentType?.ECEmployeeCategory?.Code == "A3") && a?.EmploymentType?.CostCalculationType == Domain.ECCostCalculationTypes.HourlyRate)?.toArray()?.linq?.sum((a) => a?.Cost));
}
static GetPersonnelCosts_A1A2A3_unit($this: any): any{return $this?.PerEmployeeDetails?.linq?.where((a) => (a?.EmploymentType?.ECEmployeeCategory?.Code == "A1" || a?.EmploymentType?.ECEmployeeCategory?.Code == "A2" || a?.EmploymentType?.ECEmployeeCategory?.Code == "A3") && a?.EmploymentType?.CostCalculationType == Domain.ECCostCalculationTypes.UnitCosts)?.toArray()?.linq?.sum((a) => a?.Cost);
}
static GetPersonnelCosts_A4_unit($this: any): any{return $this?.PerEmployeeDetails?.linq?.where((a) => a?.EmploymentType?.ECEmployeeCategory?.Code == "A4")?.toArray()?.linq?.sum((a) => a?.Cost);
}
static GetPersonnelCostsPercentage($this: any): any{if (($this?.Beneficiary == null || CLMS.Framework.Number.LessThanOrEqual(() => $this.Beneficiary.PersonnelCosts, () => 0))) {return 0;}
return Joove.Common.safeNumber(Domain.ProjectPersonnelClaimsReport.GetPersonnelCosts($this)) / Joove.Common.safeNumber($this?.Beneficiary?.PersonnelCosts);
}
static GetPMRateDeviation($this: any): any{if (CLMS.Framework.Number.LessThanOrEqual(() => $this.Beneficiary.PMRate, () => 0)) {return 1.0;}
return Joove.Common.safeNumber((Joove.Common.safeNumber($this?.Beneficiary?.PMRate) - Joove.Common.safeNumber($this?.ActualPMRate))) / Joove.Common.safeNumber($this?.Beneficiary?.PMRate);
}
static GetStartMonth($this: any): any{let month = Domain.Project.GetProjectMonthByDate($this?.Project, $this?.StartDate);
return (CLMS.Framework.Number.Equal(() => month, () => 0) ? 1 : month);
}
static GetTotalEstimatedEligibleCosts($this: any): any{return Joove.Common.safeNumber(Domain.ProjectPersonnelClaimsReport.GetPersonnelCosts($this)) + Joove.Common.safeNumber(Domain.ProjectPersonnelClaimsReport.GetIndirectCostsForPersonnel($this));
}
static GetTotalPersonHours($this: any): any{return $this?.PerEmployeeDetails?.linq?.sum((a) => a?.PersonHours);
}
static GetTotalPersonMonths($this: any): any{return $this?.PerEmployeeDetails?.linq?.sum((a) => a?.PersonMonths);
}
static GetTotalPMPercentage($this: any): any{return (CLMS.Framework.Number.GreaterThan(() => $this.Beneficiary.TotalEffort, () => 0) ? Joove.Common.safeNumber((Joove.Common.cast(Domain.ProjectPersonnelClaimsReport.GetTotalPersonMonths($this), "number"))) / Joove.Common.safeNumber((Joove.Common.cast($this?.Beneficiary?.TotalEffort, "number"))) : 0);
}
static SplitYearsIntoProjectPeriods($this: any, nrOfYears: any): any{let periods = [];
for (var i = 0; CLMS.Framework.Number.LessThan(() => i, () => nrOfYears); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
let currentYear = Joove.Common.safeNumber(moment($this?.StartDate).year()) + Joove.Common.safeNumber(i);let firstDayOfYear = new Date(new Date(moment([currentYear, (1) - 1, 1]).toDate())?.setHours(0, 0, 0, 0));let lastDayOfYear = new Date(new Date(moment([currentYear, (12) - 1, 31]).toDate())?.setHours(0, 0, 0, 0));if (CLMS.Framework.Number.Equal(() => $this.Project.ReportingPeriods.linq.where((a) => !(a.Informal)).toArray().length, () => 0)) {throw Error("Project " + $this?.Project?.Acronym + ", has no Formal Reporting Periods!!!");}for (let _irp = 0; _irp < ($this?.Project?.ReportingPeriods?.linq?.where((a) => !(a?.Informal))?.toArray() == null ? 0 : $this?.Project?.ReportingPeriods?.linq?.where((a) => !(a?.Informal))?.toArray().length); _irp++) {let rp = $this?.Project?.ReportingPeriods?.linq?.where((a) => !(a?.Informal))?.toArray()[_irp];let subPeriodStart = firstDayOfYear;let subPeriodEnd = lastDayOfYear;if (!(Domain.Util.DoDateRangesOverlap(rp?.StartDate, rp?.EndDate, subPeriodStart, subPeriodEnd))) {continue;}if (Domain.Util.IsDateWithinPeriod(new Date(new Date(rp?.StartDate)?.setHours(0, 0, 0, 0)), firstDayOfYear, lastDayOfYear)) {subPeriodStart = new Date(new Date(rp?.StartDate)?.setHours(0, 0, 0, 0));}if (Domain.Util.IsDateWithinPeriod(new Date(new Date(rp?.EndDate)?.setHours(0, 0, 0, 0)), firstDayOfYear, lastDayOfYear)) {subPeriodEnd = new Date(new Date(rp?.EndDate)?.setHours(0, 0, 0, 0));}periods?.add([subPeriodStart, subPeriodEnd]);}}

if (CLMS.Framework.Number.Equal(() => periods.length, () => 0)) {throw Error("Could not create periods collection for project: " + $this?.Project?.Acronym);}
return periods;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}